import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface StackTag {
  id: string;
  name: string;
  category: string;
  is_advanced: boolean;
}

export const useStackTags = () => {
  const { data: stackTags = [], isLoading } = useQuery({
    queryKey: ["stack-tags"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("stack_tags")
        .select("*")
        .order("category", { ascending: true });

      if (error) throw error;
      return data as StackTag[];
    },
  });

  const groupedByCategory = stackTags.reduce<Record<string, StackTag[]>>((acc, tag) => {
    if (!acc[tag.category]) {
      acc[tag.category] = [];
    }
    acc[tag.category].push(tag);
    return acc;
  }, {});

  const standardTags = stackTags.filter(t => !t.is_advanced);
  const advancedTags = stackTags.filter(t => t.is_advanced);

  return {
    stackTags,
    standardTags,
    advancedTags,
    groupedByCategory,
    isLoading,
  };
};
